import {Component, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import { TariffService } from '@accounts/user/services/tariff.service';
import { GasStationModel, TrailerModel } from '@core/api';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Router } from '@angular/router';
import { UserService as AuthUserService } from '@core/auth';
import { StationService } from '@accounts/user/services/station.service';
import { BottomPopupService } from '@ui/bottom-popup/bottom-popup.service';
import { MatBottomSheetRef } from '@angular/material';
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatSelect} from "@angular/material/select";
import { filterReturnStations } from '@core/utils/return-stations.helper';

@Component({
  selector: 'user-trailer-list',
  templateUrl: './trailer-list.component.html',
  styleUrls: ['./trailer-list.component.scss']
})
export class TrailerListComponent implements OnInit {

  @ViewChild('returnStationSelect') returnStationSelect: MatSelect;

  station: GasStationModel = null;
  loading: boolean = false;
  filterList: TrailerModel.TypeEnum[] = [];
  _trailers: TrailerModel[] = [];
  isSelectingReturnStation: boolean = false;
  returnStationsWithAvailableSpaces: GasStationModel[] = [];
  selectedReturnStation?: GasStationModel;
  private localReturnChosen = false;

  form: FormGroup;

  get trailers(): TrailerModel[] {
    return this._trailers.filter(trailer => {
      if (!this.filterList.includes(trailer.type)) {
        return false;
      }

      return !(this.isIntercityReturnSelected() && trailer.non_transit);
    });
  }

  set trailers(value) {
    this._trailers = value;
  }

  constructor(
    public tariffService: TariffService,
    private router: Router,
    private authUserService: AuthUserService,
    private i18n: I18n,
    public stationService: StationService,
    private bottomSheetRef: MatBottomSheetRef<TrailerListComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      return_gas_station_id: [null],
    });

    this.station = this.stationService.station;
    this.filterList = Object.values(TrailerModel.TypeEnum);
    this.getTrailers();

    if (this.station && this.station.id) {
      this.initReturnStationsSelector();
    }
  }

  private initReturnStationsSelector() {
    this.stationService.getGasStationsWithTransitSpaces(this.stationService.station.network_id).subscribe(
        (data) => {
          if (data.success && data.data.length > 0) {
            // Without a selected trailer origin filtering is applied later on the deal page.
            // Here we only apply the shared base rules (same station + other cities).
            this.returnStationsWithAvailableSpaces = filterReturnStations(
              data.data,
              this.stationService.station,
              null
            );
          }
        },
        (error) => {
          console.error('Ошибка загрузки станций:', error);
        }
    );
  }

  setDefaultReturnStation() {
    this.localReturnChosen = true;
    this.selectedReturnStation = null;
    this.isSelectingReturnStation = false;

    if (this.returnStationSelect) {
      this.returnStationSelect.close();
    }
  }

  openSelectReturnStation() {
    this.isSelectingReturnStation = true;
    setTimeout(() => {
      if (this.returnStationSelect) {
        this.returnStationSelect.open();
      } else {
        console.error('returnStationSelect не определен');
      }
    }, 0);
  }

  onReturnStationSelected() {
    this.isSelectingReturnStation = false;
    this.selectedReturnStation = this.returnStationsWithAvailableSpaces.find(
        (station) => station.id === this.form.get('return_gas_station_id').value
    );
    this.localReturnChosen = !this.selectedReturnStation
      || Number(this.selectedReturnStation.id) === Number(this.stationId);
  }

  private isIntercityReturnSelected(): boolean {
    if (this.selectedReturnStation && this.stationId != null
      && Number(this.selectedReturnStation.id) !== Number(this.stationId)) {
      return true;
    }

    if (this.localReturnChosen) {
      return false;
    }

    const filter = this.stationService.locationFilter;
    if (!filter || filter.returnLocationId == null || !filter.cityStationIds || !filter.cityStationIds.length) {
      return false;
    }

    const returnId = Number(filter.returnLocationId);
    return !filter.cityStationIds.some(id => Number(id) === returnId);
  }

  get stationId() {
    return this.station && this.station.id;
  }

  getTrailers() {
    this.trailers = this.station.trailers.filter(x => x.status == TrailerModel.StatusEnum.Available);
  }

  trailersTypes = [
    { name: 'Тентовый', type: TrailerModel.TypeEnum.WithTent },
    { name: 'Без тента', type: TrailerModel.TypeEnum.WithoutTent }
  ];

  detail(trailer: TrailerModel) {
    this.tariffService.trailer = trailer;
    this.bottomSheetRef.dismiss();

    const route = ['/cabinet/new/', this.stationId, trailer.id];

    if (this.selectedReturnStation && this.selectedReturnStation.id) {
      route.push(this.selectedReturnStation.id);
    }

    this.router.navigate(route);
  }

  ngOnInit() {
    this.loading = false;
  }

  changeFilter(filter: TrailerModel.TypeEnum) {
    if (this.filterList.includes(filter)) {
      this.filterList = this.filterList.filter(x => x != filter);
    } else {
      this.filterList.push(filter);
    }
  }
}

@Pipe({ name: 'trailer' })
export class TrailerPipe implements PipeTransform {

  constructor(private i18n: I18n) { }

  transform(value: any, type: 'type' | 'adapter') {

    switch (type) {
      case 'type':
        return value === 'with_tent' ? this.i18n('с тентом') : this.i18n('без тента');
      case 'adapter':
        return value ? this.i18n('с адаптером') : this.i18n('без адаптера');
      default:
        return value;
    }
  }
}
